'use strict';

export default { checkPages, getPage };

const storagePrefix = 'trackPage_';


const trackPages = {
	product: {
		paths: ['/fi/tuote/'],
		pathValidation: (path) => window.location.pathname.indexOf(path) === 0,
		getValue: () => {
			const urlParams = new URLSearchParams(window.location.search);
			const sap = window.location.pathname.split('/').slice(-2)[0].split('-').pop()
			const color = urlParams.get('color');
			return [sap, color].filter(Boolean).join('_');
		},
		limit: 11,
		ttl: 86400 * 30
	}
};

/**
 * Go through all tracked pages and save value when path validation returns true.
 */
export function checkPages() {
	for (const key in trackPages) {
		const page = trackPages[key];

		for (let path of page.paths) {
			if (page.pathValidation(path)) {
				savePage(key, page.getValue(), page.limit, page.ttl);
				break;
			}
		}
	}
}

/**
 * Get saved page values as an array.
 *
 * @param {String} key
 *
 * @return {Array|Boolean} - Returns false if key doesn't exist or it has expired TTL
 */
export function getPage(key) {
	try {
		const now = new Date().getTime();
		const item = JSON.parse(localStorage.getItem(storagePrefix + key));

		if (item && (!item.ttl || item.ttl > now)) {
			return item.value;
		} else {
			localStorage.removeItem(storagePrefix + key);
		}
	} catch (e) {
		console.log(e);
	}

	return false;
}

/**
 * Prepends a given value to a given key in an array and optionally limits total number of items.
 * Also sets TTL if exists.
 *
 * @param {String} key
 * @param {String} value
 * @param {Number} [limit]
 * @param {Number} [ttl] - TTL in seconds
 *
 * @return {Boolean} - Returns true/false depending if save was successful
 */
function savePage(key, value, limit, ttl) {
	const pageValues = getPage(key);
	let newValues;

	if (pageValues && Array.isArray(pageValues)) {
		newValues = pageValues;

		// Make sure we don't have duplicate values
		const valueIndex = newValues.indexOf(value);
		if (valueIndex !== -1) {
			newValues.splice(valueIndex, 1);
		}

		newValues.unshift(value);

		if (limit && !isNaN(limit)) {
			newValues = newValues.slice(0, parseFloat(limit));
		}
	} else {
		newValues = [value];
	}

	try {
		const now = new Date().getTime();

		localStorage.setItem(storagePrefix + key, JSON.stringify({
			ttl: ttl && !isNaN(ttl) ? (parseFloat(ttl) * 1000) + now : 0,
			value: newValues
		}));

		return true;
	} catch(e) {
		console.log(e);
	}

	return false;
}
